<template>
  <b-modal
    id="details"
    no-enforce-focus
    title="Cadastro de Banner"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
  >
    <div v-if="!loading" class="grid-web">
      <!-- Upload Image -->
      <b-col cols="12" style="display: flex; width: 100%; justify-content: center;">
        <div v-if="attachment && !payload.url_banner" class="file-inner">
          <img style="border-radius: 5px; width: 100%;" :src="attachment" />
          <span style="cursor: pointer;" @click="removeImage">Remover Imagem</span>
        </div>
        <div v-if="!attachment && payload.url_banner" class="file-inner">
          <img style="border-radius: 5px; width: 100%;" :src="`https://greenn.nyc3.digitaloceanspaces.com/${payload.url_banner}`" />
          <span style="cursor: pointer;" @click="removeImage">Remover Imagem</span>
        </div>
        <label v-if="!payload.url_banner && !attachment" for="file-upload" class="custom-file-upload">
          <div class="file-inner"></div>
          <img style="position: relative" class="pointer" src="../../../assets/images/paperclip.svg" />
          <h4 style="color: grey;">640 x 100</h4>
        </label>
        <input
          id="file-upload"
          accept="image/png, image/jpeg, image/jpg"
          type="file"
          @change="setFile"
        />
      </b-col>
      <div class="row">
        <!-- Name -->
        <div class="col-12">
          <b-form-input v-model="payload.image_name" placeholder="Informe um nome para o banner"></b-form-input>
        </div>
        <!-- Redirect Link -->
        <div class="col-12 mt-2">
          <b-form-input v-model="payload.url_redirect" placeholder="Link de redirecionamento"></b-form-input>
        </div>
        <!-- Active? -->
        <div class="col-12 mt-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="payload.ativo"
            name="checkbox-1"
          >
            Definir este banner como ativo?
          </b-form-checkbox>
        </div>
        <!-- Save -->
        <div class="col-12 mt-3 pa-2">
          <b-button variant="success" @click="saveOrCreate"> Salvar </b-button>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment'
import Money from '@src/mixins/money'
import bannerservice from '@services/resources/GenericService'

var service = bannerservice.build()

export default {
  mixins: [Money],
  props: {
    payload: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      moment: moment,
      attachment: '', 
      loading: false,
    }
  },
  computed: {
    canSave() {
      return !!(this.attachment !== '' && this.payload.nome)
    }
  },
  methods: {
    setFile(e) {
      var file = e.target.files[0]
      var reader = new FileReader()
      const self = this
      reader.onloadend = function () {
        self.attachment = reader.result
      }
      reader.readAsDataURL(file)
      this.$forceUpdate()
    },
    removeImage() {
      this.attachment = ''
      this.payload.url_banner = ''
    },
    saveOrCreate() {
      this.loading = true
      if(this.payload.id) this.updateBanner()
      else this.createBanner()
    },
    createBanner() {
      let data = {
        attachment: this.attachment,
        image_name: this.payload.image_name,
        url_redirect: this.payload.url_redirect
      }
      data.ativo = this.payload.ativo ? 1 : 0

      service.create(data, false, '/store/attachement')
        .then(() => {
          this.$bvToast.toast('o banner foi criado com sucesso!', {
            variant: 'success',
            title: 'Banner criado!',
            autoHideDelay: 5000
          })
          this.$bvModal.hide('details')
          this.removeImage()
          this.$store.dispatch('fetchBanners')
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            variant: 'danger',
            title: 'Erro ao criar o banner!',
            autoHideDelay: 5000
          })
        })
        .finally(() => { this.loading = false })
    },
    updateBanner() {
      let data = this.payload
      
      if(!this.payload.url_banner && !this.attachment) {
        this.$bvToast.toast('Selecione uma imagem!', {
          variant: 'danger',
          title: 'Uma imagem é necessária!',
          autoHideDelay: 5000,
        })
        this.loading = false
        return
      }

      if(this.attachment && !this.payload.url_banner) data.attachment = this.attachment

      service.create(this.payload, null, `/banner/${this.payload.id}`)
        .then(() => {
          this.$bvToast.toast('o banner foi atualizado com sucesso!', {
            variant: 'success',
            title: 'Banner atualizado!',
            autoHideDelay: 5000,
          })
          this.$bvModal.hide('details')
          this.removeImage()
          this.$store.dispatch('fetchBanners')
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            variant: 'danger',
            title: 'Erro ao atualizar o banner!',
            autoHideDelay: 5000,
          })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style lang="scss">
.grid-web {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}

input[type='file'] {
  display: none;
}

.file-inner {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-file-upload {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
  min-width: 100%;
  background: #f7f7f7;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}
</style>
